// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .sk-collapse-header[data-v-a5fbea4c] {\n  box-shadow: 0px 0px 15px 0px rgba(210, 210, 215, 0.7);\n  border-color: #d8d6de;\n  border-color: rgba(216, 214, 222, 0.5);\n}\n", ""]);
// Exports
module.exports = exports;
